import {Button, Icon, Link, Tooltip} from '@startlibs/components';
import {callIfFunction, getColor, preventDefault} from '@startlibs/utils';
import {usePopupToggle} from '@startlibs/core'
import React from 'react'
import styled, {css} from 'styled-components';
import {
  CASE_CLOSED,
  CASE_REVIEWED,
  UNDER_REVIEW,
  WAITING_ACCEPTANCE,
  WAITING_MORE_INFORMATION,
} from '../enums/CaseState';
import {RequestCard} from '../admin/CaseRequestCard'
import {formatDateNoUTC, HIDDEN} from '../utils/utils'
import {IfLocale} from '../hocs/IfLocale';
import {FormattedMessage, useIntl} from "react-intl";
import {defaultDateTimeFormat} from "../utils/dateFormat";
import { lazyProviderInfo } from '../components/WithProvider';

const ActionsWrapper = styled.div`
  position: absolute;
  top: .75rem;
  right: .75rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .priority-icon {
    cursor: pointer;
    ${props => props.viewOnly && css`
      cursor: default;
    `}
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    color: ${getColor('warning')};
    background-color: ${getColor('lightYellow')};
    border-radius: 6px;
    font-size: 20px;
    margin-right: .5rem;
    ${Icon} {
      margin-top: -2px;
    }
  }
`
const DoneLabel = styled.div`
  margin-left: auto;
  color: ${getColor('success')};
  background: ${getColor('lightGreen')};
  border-radius: 5px;
  padding: 2px 0.75rem 3px 0.5rem;
  display: inline-flex;
  align-items: center;
  position: absolute;
  right: 0.25rem;
  //font-size:
`


export const ExpertCaseCard = ({caseRequest, isResults, showFooter, contextMenu, onClick, linkTo}) => {
  const contextMenuToggle = usePopupToggle()
  const intl = useIntl()
  const providerInfo = lazyProviderInfo.read()
  const requestCodeForExpert = providerInfo?.requestCodeForExpert || HIDDEN // SHOW|HIDDEN|MASKED
  
  const getStatusLabel = (state, isCoReview, hasCoReviewFinish, _is) => {
    if(isCoReview){
      // return <div className="status"><Icon icon="view"/> <span>Read only</span> {hasCoReviewFinish && <DoneLabel><Icon icon="check"/>Done</DoneLabel>}</div>
      return <div className="status">
          <Icon icon="view"/> <span><FormattedMessage defaultMessage="Read only" description="Expert case card read only label"/> </span>
          {hasCoReviewFinish && (state == WAITING_ACCEPTANCE || state == UNDER_REVIEW || state == WAITING_MORE_INFORMATION) &&
            <DoneLabel>
              <Tooltip content={intl.formatMessage({
                defaultMessage:"This case is still active as another Expert’s review is in progress.",
                description:"Expert case card tooltip for done when still in review from another expert"
              })}>
                <span css="display: flex; align-items: center;"><Icon icon="check"/>
                  {/* <FormattedMessage description="Done" defaultMessage="Expert case card done label"/> */}
                  <FormattedMessage description="Expert case card done label" defaultMessage="Done"/>
                </span>
              </Tooltip>
            </DoneLabel>
          }
          {hasCoReviewFinish &&  (state !== WAITING_ACCEPTANCE && state !== UNDER_REVIEW && state !== WAITING_MORE_INFORMATION) &&
            // <DoneLabel><Icon icon="check"/> <FormattedMessage description="Done" defaultMessage="Expert case card done label"/> </DoneLabel>
            <DoneLabel><Icon icon="check"/> <FormattedMessage description="Expert case card done label" defaultMessage="Done"/> </DoneLabel>
          }
      </div>
    }
    switch (state) {
      case WAITING_ACCEPTANCE:
        return <div className="status"><Icon icon="failure"/> <span>
        {/* <FormattedMessage description="Pending acceptance" defaultMessage="Expert case card waiting acceptance label"/> */}
        <FormattedMessage description="Expert case card waiting acceptance label" defaultMessage="Pending acceptance"/>
      </span></div>
      case UNDER_REVIEW:
      case WAITING_MORE_INFORMATION:
        return <div className="status"><Icon icon="edit-box"/> <span>
        {/* <FormattedMessage description="Under review" defaultMessage="Expert case card under review label"/> */}
        <FormattedMessage description="Expert case card under review label" defaultMessage="Under review"/>
      </span></div>
      case CASE_REVIEWED: return <div className="status"><Icon icon="check"/> <span>
        {/* <FormattedMessage description="Review submitted" defaultMessage="Expert case card review submitted label"/> */}
        <FormattedMessage description="Expert case card review submitted label" defaultMessage="Review submitted"/>
      </span></div>
      case CASE_CLOSED: return <div className="status"><div className="finished-icon"><Icon icon="check"/></div> <span>
        {/* <FormattedMessage description="Case completed" defaultMessage="Expert case card case completed label"/> */}
        <FormattedMessage description="Expert case card case completed label" defaultMessage="Case completed"/>
      </span></div>
    }
  }

  return <RequestCard
    as={linkTo ? Link : undefined}
    viewOnly={!contextMenu}
    isResults={isResults}
    onClick={onClick}
    to={linkTo}
    isPriority={caseRequest.markedAsPriorityEpochMilli}
    isExpert
  >
    {contextMenu && <ActionsWrapper>
      {
        caseRequest.markedAsPriorityEpochMilli &&
        <Tooltip content={intl.formatMessage({
          defaultMessage:"This case was marked as priority.",
          description:"Expert case card tooltip for priority case"
        })}>
          <div className="priority-icon" onClick={e=> {e.preventDefault();e.stopPropagation()}}>
            <Icon icon="star"/>
          </div>
        </Tooltip>
      }
      <Button small onlyDropdown onClick={preventDefault(contextMenuToggle.toggle)}>
        {callIfFunction(contextMenu,contextMenuToggle.isOpen)}
      </Button>
    </ActionsWrapper>
    }
    {!contextMenu && caseRequest.markedAsPriorityEpochMilli &&
      <ActionsWrapper viewOnly>
        <Tooltip content={intl.formatMessage({
          defaultMessage:"This case was marked as priority.",
          description:"Expert case card tooltip for priority case"
        })}>
          <div className="priority-icon" onClick={e=> {e.preventDefault();e.stopPropagation()}}>
            <Icon icon="star"/>
          </div>
        </Tooltip>
      </ActionsWrapper>
    }
    <div className="main-content">
      <div className="patient-name fs-exclude"><Icon icon="user-line"/> <FormattedMessage
          defaultMessage="{firstName} {middleName} {lastName}"
          description="Expert case card patient name"
          values={{
            firstName: (caseRequest.firstName || caseRequest.patientInfo.firstName),
            middleName: ((caseRequest.middleName ? caseRequest.middleName + ' ' : '') || (caseRequest.patientInfo?.middleName ? caseRequest.patientInfo?.middleName + ' ' : '')),
            lastName: (caseRequest.lastName || caseRequest.patientInfo?.lastName)
          }}
        />
      </div>
      {/* Case ID for EXPERT - Check provider info */}
      {requestCodeForExpert !== HIDDEN && <div className="code"><b><FormattedMessage defaultMessage="Case ID: " description='CaseRequestCard admin caseid item label'/> </b>{caseRequest.requestCode}</div>}
      <IfLocale contains="LEGAL">
        {caseRequest?.legalInfo?.caseNumber?.length > 0 
          ? <div className="code"><b>Case Number:</b> {caseRequest.legalInfo.caseNumber}</div>
          :  null
        }
      </IfLocale>
      <div className="last-update">
        <FormattedMessage
          defaultMessage="Last updated on <nowrap>{date}</nowrap>"
          description="Expert case card last updated label"
          values={{
            nowrap: (chunks) => <span className="nowrap">{chunks}</span>,
            date: formatDateNoUTC(new Date(caseRequest.whenModifiedEpochMilli), defaultDateTimeFormat(intl))
          }}
        />
      </div>
    </div>
    {(showFooter || caseRequest.isCoReview) &&
    <div className={"card-footer" + (caseRequest.isCoReview ? " coreview" : "")}>
      {getStatusLabel(caseRequest.state, caseRequest.isCoReview, caseRequest.coReviewDateEpochMilli !== null)}
    </div>}
  </RequestCard>
}
